export default "__VITE_ASSET__CokaMSVC__"